import React, { useContext, useState } from 'react';
// src/index.js or src/App.js
import 'bootstrap/dist/css/bootstrap.min.css';
import { StockContext } from '../Context/StockContext';
import './TimeFrameFilter.css';



const TimeFrameFilter = () => {
  const [radioValue, setRadioValue] = useState(0);
  const [isWeeksActive, setIsWeeksActive] = useState(true);
  const { handleSubmit, handleUpdate, user } = useContext(StockContext);

  // const [payment, setPayment] = useState({})

  // useEffect(()=>{
  //   if(userPayment.amount && !NaN(userPayment.amount)){
  //     handlePaymentInfo({userPayment});
  //     alert(`You had deposited Rs.${paid}`)
  //   }
  // },[userPayment.amount])

  const weeks = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  function handleButtonClick(e) {
    setIsWeeksActive(!isWeeksActive);
  }

  function handleRadioInput(e) {
    setRadioValue(Number(e.target.value));
  }

  // console.log(handleSubmit)


  // Handle submit button
  const onSubmit = () => {
    handleSubmit(Number(radioValue), isWeeksActive ? 'weeks' : 'months')
  }

  const timeOptions = isWeeksActive ? weeks : months;


  return (
    <section className="TimeFrameFilter-container rounded my-1">


        <div className='TimeFrameFilter-button'>
          <button type="button" className={`btn btn-${isWeeksActive ? 'primary' : 'light border'} m-1  rounded-pill btn-sm `} onClick={handleButtonClick}>Weeks</button>
          <button type="button" className={`btn btn-${!isWeeksActive ? 'primary' : 'light border'} m-1  rounded-pill btn-sm `} onClick={handleButtonClick}>Months</button>
        </div>

        <div className='TimeFrameFilter-passage'>
          <i className='small text-center custom-passage'>compare with past {radioValue} {isWeeksActive ? 'weeks' : 'months'}</i>
        </div>


        <div className="TimeFrameFilter-input border rounded">
          <div className='d-flex flex-row flex-wrap p-2 mx-2 justify-content-center align-items-center'>
            {timeOptions.map((time, index) => (
              // <div className="form-check m-2 border rounded-pill d-flex justify-content-center align-items-center" key={time}>
              //   <label className="form-check-label px-1" htmlFor={`time_weeks_months${index}`}>
              //     <input className="form-check-input" type="radio" id={`time_weeks_months${index}`} value={time} onChange={handleRadioInput} checked={radioValue === Number(time)} />
              //     {time}
              //   </label>
              // </div>

              <div className="btn-group-vertical mx-1 d-flex" role="group" key={time}>
                <input type="radio" className="btn-check" id={`time_weeks_months${index}`} value={time} onChange={handleRadioInput} checked={radioValue === Number(time)} />
                <label className="btn btn-outline-primary btn-custom m-1" 
                htmlFor={`time_weeks_months${index}`} 
                // style={{ width: '80px' }}
                >
                  {time}
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="TimeFrameFilter-submit m-2">
          <button type="button" className="btn btn-sm btn-primary rounded custom-submit" onClick={onSubmit}>Submit</button>
        </div>

        <div className="TimeFrameFilter-Update">
          <button type="button" className="btn btn-sm rounded custom-update" onClick={()=>handleUpdate(user)}>Update latest price</button>
        </div>


    </section>
  );
};

export default TimeFrameFilter;